import React from 'react';
import PropTypes from 'prop-types';
import s from './HeadLine.module.scss';
import classNames from 'classnames';

const HeadLine = ({ title = '', children, size = 'Large' }) => {
    const classes = classNames(s.Root, s[`Root--${size}`]);

    return (
        <div className={classes}>
            {children}
            {size === 'Large' ? (
                <h1 className={s.HeadLine}>{title}</h1>
            ) : (
                <h2 className={s.HeadLine}>{title}</h2>
            )}
        </div>
    );
};

HeadLine.propTypes = {
    title: PropTypes.string,
    children: PropTypes.node,
    size: PropTypes.oneOf(['Small', 'Medium', 'Large']),
};

export default HeadLine;
